import { ShiftType } from "../constants";
import { PriorityShiftPill } from "../Priority/Pill";
import { ShiftAuctionPill } from "../ShiftAuction/Pill";
import { UrgentShiftPill } from "../Urgent/Pill";

interface ShiftBottomSheetHeaderPillProps {
  shiftType: ShiftType;
  hasShiftAuction: boolean;
}

/**
 * Renders pill related to the open shift
 * - Urgent
 * - Priority
 */
export function ShiftBottomSheetHeaderPill(props: ShiftBottomSheetHeaderPillProps) {
  const { shiftType, hasShiftAuction } = props;

  const showUrgentPill = shiftType === ShiftType.URGENT;

  const showShiftAuctionPill = hasShiftAuction;

  const showPriorityPill =
    shiftType === ShiftType.PRIORITY || shiftType === ShiftType.PRIORITY_LEGACY;

  if (showShiftAuctionPill) {
    return <ShiftAuctionPill variant="icon-highlight" size="medium" />;
  }

  if (showUrgentPill) {
    return <UrgentShiftPill variant="icon-highlight" size="medium" />;
  }

  if (showPriorityPill) {
    return <PriorityShiftPill variant="icon-highlight" size="medium" />;
  }

  return null;
}
